import {
  SoftwareBlenderColor,
  Software3dsmaxColor,
  SoftwareMaya,
  SoftwareUnity,
  SoftwareUnreal,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

const ICONS = {
  SoftwareBlenderColor,
  Software3dsmaxColor,
  SoftwareMaya,
  SoftwareUnity,
  SoftwareUnreal,
}

export const resolveSoftwareIcon = (iconName) => ICONS[iconName] || null
